import baseRoute from '../baseRoute';

export type * from './viewModel';

export type ReportSourceType = 'reportBlock' | 'reportType';

type RouteDefinition = `${typeof baseRoute}/templatesForReportSource/${ReportSourceType | ':sourceType'}/${number | ':sourceId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/templatesForReportSource/:sourceType/:sourceId`;

export const URL = (
	sourceType: ReportSourceType,
	sourceId: number
): RouteDefinition => `${baseRoute}/templatesForReportSource/${sourceType}/${sourceId}`;
